<div class="card p-4 border-2">
  <div class="title text-base font-medium mb-3" (click)="onTitleClick()">
    {{ kpiData.title }}
  </div>
  @if (!kpiData.count && !kpiData.details) {
    <p-skeleton height="2rem"></p-skeleton>
  } @else {
    <div class="flex align-items-center">
      <span class="count text-4xl font-medium mr-2">{{ kpiData.count }}</span>
      @if (kpiData.details) {
        <span class="details text-sm text-ellipsis" [pTooltip]="kpiData.details" tooltipPosition="top">
          {{ kpiData.details }}
        </span>
      }
    </div>
  }
</div>
